<script lang="ts">
    export let chartElm = null;
    export let chart = null;
    import Highcharts from "highcharts";

    const DEFAULT_MEX_LEN = 30;

    Highcharts.setOptions({
        /* time: {
            timezone: "Europe/Rome",
        }, */
        /* ==================
                    TODO
            ================== */
        global: {
            timezoneOffset: -1 * 60,
        } as any,
    });
    let graphMaxLen = -1;
    // let graphMaxTimestamp = null;
    let primSeriese = -1;
    let ehanolMetaData: { [key: number]: { len: number; last } } = {};
    let animaitonLock = false;
    function clarAndInitChart() {
        if (!chartElm) {
            // ======= TODO TODO TODO ========
            setTimeout(() => {
                clarAndInitChart();
            }, 100);
            return;
        }
        const charConfig = {
            chart: {
                renderTo: chartElm,
                type: "spline",
            },
            exporting: {
                enabled: false,
            },

            /* title: {
                    align: "left",
                    text: "Náhled teplot",
                }, */
            title: { text: "" },

            xAxis: {
                type: "datetime",
                // tickInterval: 1000,
                // tickPixelInterval: 200,
                minRange: 1000 * 10 * 2,
                tickWidth: 2,
                tickLength: 30,
                tickInterval: 1000 * 10,
            },

            yAxis: [
                {
                    // left y axis
                    /* softMax: 10,
                        softMin: 0, */
                    title: {
                        text: null,
                    },
                    labels: {
                        align: "left",
                        x: 3,
                        y: 16,
                        format: "{value:.,0f}",
                    },
                    showFirstLabel: false,
                },
                {
                    // right y axis
                    linkedTo: 0,
                    gridLineWidth: 0,
                    opposite: true,
                    title: {
                        text: null,
                    },
                    labels: {
                        align: "right",
                        x: -10,
                        y: 16,
                        format: "{value:.,0f}",
                    },
                    showFirstLabel: false,
                },
            ],

            legend: {
                align: "left",
                verticalAlign: "bottom",
                borderWidth: 0,
            },
            tooltip: {
                formatter: function () {
                    /* <b>${this.x}</b><br> */
                    return `<b>${this.y}</b>°C`;
                },
                shared: true,
                crosshairs: true,
            },

            plotOptions: {
                series: {
                    cursor: "pointer",
                    className: "popup-on-click",
                    marker: {
                        lineWidth: 1,
                    },
                },
            },
            series: [],
        };

        chart = new Highcharts.Chart(charConfig as any);
        /* chart.addSeries({
                name: "Etalon č. 1",
                lineWidth: 4,
                marker: {
                    radius: 6,
                },
            });
            const series = chart.series[0];
            setInterval(() => {
                const x = new Date().getTime();
                const y = Math.round(Math.random() * 100);
                series.addPoint([x, y]);
                // console.log(series, new Date().getTime());
            }, 1000); */
    }
    function addSeries(ser) {
        if (!chart) {
            clarAndInitChart();
        }
        const series = chart.addSeries(ser);
        series.afterAnimate = (x) => {
            console.log('AC', x);
        }
        const newSerId = chart.series.length - 1;
        return newSerId;
    }

    function clearAllAfterTime(ts) {
        for (let i = 0; i < chart.series.length; i++) {
            const ser = chart.series[i];
            while (ser.data.length !== 0 && ser.data[0].x < ts) {
                ser.removePoint(0, true);
            }
        }
    }

    function checkAndUpdatePrimLen(prSerId) {
        if (
            prSerId !== -1 &&
            graphMaxLen !== -1 &&
            chart.series.length > prSerId &&
            chart.series[prSerId].data.length > graphMaxLen
        ) {
            // console.log(prSerId, graphMaxLen, chart.series[prSerId].data.length)
            /*  let removeCount = 0;
            for (; chart.series[prSerId].data.length > graphMaxLen; removeCount++) {
                // chart.series[prSerId].removePoint(0, true);
                chart.series[prSerId].remove(0, true);
            } */
            while (chart.series[prSerId].data.length > graphMaxLen) {
                chart.series[prSerId].removePoint(0, true);
            }
            /* if (chart.series[prSerId].data.length > graphMaxLen) {
                chart.series[prSerId].removePoint(0, true); 
            } */
            if (chart.series[prSerId].data.length !== 0) {
                // const lastIndex = chart.series[prSerId].data.length -1;
                clearAllAfterTime(chart.series[prSerId].data[0].x);
            }
        }
    }

    export const controls = {
        clarAndInit: clarAndInitChart,
        clearData: () => {
            graphMaxLen = -1;
            // graphMaxTimestamp = null;
            primSeriese = -1;
            ehanolMetaData = {};
            if (!chart) {
                clarAndInitChart();
            }
            chart.series.forEach((ser) => {
                while (ser.data.length !== 0) {
                    ser.removePoint(0, false, false);
                }
            });
            chart.redraw();
        },
        addEthanol: (name) => {
            console.log("[INFO - graph add eth]");
            const ret = addSeries({
                name: name,
                lineWidth: 4,
                marker: {
                    radius: 0,
                },
            });
            if (primSeriese === -1) {
                primSeriese = ret;
            }
            /*  ehanolMetaData[ret] = {
                len: 0,
            } */
            return ret;
        },
        addProbe: (name) => {
            return addSeries({
                name: name,
                lineWidth: 1,
                marker: {
                    radius: 0,
                },
            });
        },
        pushVal: (serId, val, timestamp) => {
            if (!chart || serId < 0 || serId >= chart.series.length) {
                console.warn(
                    "wanr cannot show data in graph",
                    serId,
                    val,
                    timestamp
                );
                return;
            }
            chart.series[serId].addPoint([timestamp, val]);
            if (serId == primSeriese) {
                checkAndUpdatePrimLen(primSeriese);
            }
        },
        setMaxLength: (len) => {
            graphMaxLen = len;
            checkAndUpdatePrimLen(primSeriese);
            /* if (
                !chart ||
                serId < 0 ||
                serId >= chart.series.length ||
                !(serId in seriesMetaMap)
            ) {
                console.warn("wanr cannot change len in graph", serId, len);
                return;
            }
            seriesMetaMap[serId].len = 0;
            while (chart.series[serId].data.length > seriesMetaMap[serId].len) {
                chart.series[serId].removePoint(0, false, false);
            }
            chart.redraw(); */
        },
    };

    /* Highcharts.addEvent(Highcharts.Point, "click", function () {
            if (
                this.series.options.className.indexOf("popup-on-click") !== -1
            ) {
                const chart = this.series.chart;
                // const date = Highcharts.dateFormat("%A, %b %e, %Y", this.x);
                // const date = Highcharts.dateFormat("", this.x);
                const date = this.x;
                console.log(this.x);
                const text = `<b>${date}</b><br/>${this.y} ${this.series.name}`;

                const anchorX = this.plotX + this.series.xAxis.pos;
                const anchorY = this.plotY + this.series.yAxis.pos;
                const align =
                    anchorX < chart.chartWidth - 200 ? "left" : "right";
                const x = align === "left" ? anchorX + 10 : anchorX - 10;
                const y = anchorY - 30;
                if (!chart.sticky) {
                    chart.sticky = chart.renderer
                        .label(text, x, y, "callout", anchorX, anchorY)
                        .attr({
                            align,
                            fill: "rgba(0, 0, 0, 0.75)",
                            padding: 10,
                            zIndex: 7, // Above series, below tooltip
                        })
                        .css({
                            color: "white",
                        })
                        .on("click", function () {
                            chart.sticky = chart.sticky.destroy();
                        })
                        .add();
                } else {
                    chart.sticky
                        .attr({ align, text })
                        .animate({ anchorX, anchorY, x, y }, { duration: 250 });
                }
            }
        }); */

    /* setTimeout(() => {
        controls.clarAndInit();
    }); */
</script>

<div class="root">
    <div bind:this={chartElm} id="container" />
</div>

<style>
    .root {
        padding: 0 2rem;
        box-sizing: border-box;
        background: var(--back);
        min-height: 400px;
        max-width: calc(100% - 2rem - 13rem -20px);
    }
</style>
